import type { IconNode } from '../types';

/**
 * @name slot-card-credit
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNyAxM0g0YTIgMiAwIDAgMS0yLTJWN2EyIDIgMCAwIDEgMi0yaDE2YTIgMiAwIDAgMSAyIDJ2NGEyIDIgMCAwIDEtMiAyaC0zIiAvPgogIDxwYXRoIGQ9Ik02IDloMTIiIC8+CiAgPHBhdGggZD0iTTE3IDl2OC4zYzAgLjktLjkgMS43LTIgMS43SDljLTEuMSAwLTItLjctMi0xLjdWOSIgLz4KICA8cGF0aCBkPSJNMTEgOXYxMCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/slot-card-credit
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const slotCardCredit: IconNode = [
  [
    'path',
    {
      d: 'M7 13H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-3',
      key: 's0ohus',
    },
  ],
  ['path', { d: 'M6 9h12', key: 'oae0tv' }],
  ['path', { d: 'M17 9v8.3c0 .9-.9 1.7-2 1.7H9c-1.1 0-2-.7-2-1.7V9', key: '1xoavi' }],
  ['path', { d: 'M11 9v10', key: '1yhlux' }],
];

export default slotCardCredit;
